import React from "react";
import "../UserManagement/UserManagement.scss";
import CommonTable from "../../../components/AdminComponents/CommonTable/CommonTable";

const UserManagement = () => {
  return (
    <>
    <div className='admin-content-wrapper'>
      <div className="admin-content-subheader">
        <div className="admin-content-subheader-title">User Management</div>
      </div>

      <CommonTable />
    </div>
    </>
  );
};

export default UserManagement;
